module.exports = __webpack_public_path__ + "img/border_et_polygon.94f1cc55.svg";